module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "installation"
  }, [_c('h1', [_vm._v("Installation")]), _vm._v(" "), _c('div', [_vm._v("\n        You have successfully installed Storyblok Commerce."), _c('br'), _vm._v("\n        To get started please read the setup guide.\n        "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Public API-Key")]), _vm._v("\n        Use this key to get the catalogue data and to manage the cart.\n        "), (_vm.public) ? _c('div', {
    staticClass: "apikey"
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.public.key),
      callback: function($$v) {
        _vm.$set(_vm.public, "key", $$v)
      },
      expression: "public.key"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Private API-Key")]), _vm._v("\n        Use this key to get full access to orders and the catalogue. "), _c('br'), _vm._v("\n        DON'T share the private token in public!\n        "), (_vm.private) ? _c('div', {
    staticClass: "apikey"
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.private.key),
      callback: function($$v) {
        _vm.$set(_vm.private, "key", $$v)
      },
      expression: "private.key"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "installation__button"
  }, [_c('a', {
    staticClass: "el-button el-button--primary",
    attrs: {
      "target": "_blank",
      "href": "https://www.storyblok.com/commerce/docs/setup"
    }
  }, [_vm._v("Open setup guide")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0929abb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Install.vue
// module id = 519
// module chunks = 1